import InnerHTMLContainer from '../../../molecules/InnerHTMLContainer';
import { Typography } from '../../../molecules/Typography';
import { useNewContentCardContext } from '../useNewContentCardContext';

interface INewContentCardTitleProps {
  title: string;
  compactText?: boolean;
  isHtml?: boolean;
}

export function NewContentCardTitle({
  title,
  compactText = false,
  isHtml = false,
}: INewContentCardTitleProps) {
  const { discipline } = useNewContentCardContext();

  if (isHtml) {
    return (
      <InnerHTMLContainer
        data={title}
        type='contentCard'
        align='left'
        font='noto'
        className='text-sm text-mono-color-darkest transition delay-100 ease-in-out group-hover:text-card-color-default'
      />
    );
  }

  return (
    <Typography
      type='title'
      size={compactText ? 'h5' : 'h4'}
      className={`${
        discipline && discipline !== 'default'
          ? 'transition delay-100 ease-in-out group-hover:text-card-color-default'
          : ''
      }`}
    >
      {title}
    </Typography>
  );
}
